export const dashboardRootText = {
  quota: 'Storage Quota',
  plan: 'Silver Basic',
  usersQuota: 'Amount of users',
  mb: 'MB',
  users: 'Users',
};
